import {useTransform, useSpring, MotionValue} from 'motion/react';
import {ANIMATION_CONFIG} from './animation-config';

export const useAvatarScroll = (mainScrollProgress: MotionValue<number>) => {
    const avatarX = useTransform(mainScrollProgress, [0, 1], [0, -800]);
    const smoothAvatarX = useSpring(avatarX, ANIMATION_CONFIG.AVATARS.X);

    const containerScale = useTransform(mainScrollProgress, [0, 0.5, 1], [0.98, 1, 0.98]);
    const smoothScale = useSpring(containerScale, ANIMATION_CONFIG.AVATARS.SCALE);

    return {
        avatarX: smoothAvatarX,
        containerScale: smoothScale,
    };
};
